exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".priceContainer{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/PriceEditor.vue
// module id = 217
// module chunks = 11